// Guest-facing kiosk translations. API ids (allergy/diet/occasion codes) stay in
// English — these are display labels only.
export const translations = {
  "en": {
    "warn_title": "Please Check Your Details",
    "notice_title": "This Couldn't Be Completed",
    "error_title": "Something Needs Your Attention",
    "ok": "OK",
    "arrival": "Arrival",
    "departure": "Departure",
    "room_no": "Room No.",
    "view_menu": "View Menu",
    "gluten_free_menu": "Gluten-Free Menu",
    "and": "and",
    "nights": "Nights",
    "board": "Board",
    "guests": "Guests",
    "err_invalid_room": "Room {room} is not a valid room number.",
    "err_no_stay": "Room {room} is not currently in-house.",
    "err_departure_required": "Please select your departure date.",
    "err_mismatch": "Room number and departure date do not match our records.",
    "err_past_date": "This date has already passed.",
    "err_outside_stay": "This date is outside your stay.",
    "err_maintenance": "The system is closed for maintenance.",
    "err_work_time": "Reservations are open between {open} and {close}.",
    "err_no_shared": "Shared tables are not available at this restaurant.",
    "err_companion_not_found": "No in-house guest in room {room}.",
    "err_companion_mismatch": "Room {room}: the departure date does not match.",
    "err_last_day": "Reservations are not possible on your departure day.",
    "err_same_day_closed": "Same-day reservations close at {time}.",
    "err_same_day_limit": "Only {n} reservation(s) allowed per day.",
    "err_slot_closed": "This time is no longer available.",
    "err_slot_full": "Only {n} seats left at {time}.",
    "err_disabled": "My Reservations is currently not available.",
    "err_cancel_disabled": "Please contact reception to cancel this reservation.",
    "err_cancel_closed": "Same-day cancellations close at {time}.",
    "err_cancel_not_found": "This reservation can no longer be cancelled.",
    "err_min_stay": "Reservations require a stay of at least {n} nights.",
    "err_quota": "The reservation quota for your stay has been used.",
    "err_quota_window": "Your board allows {n} reservation(s) per {days} day(s).",
    "err_no_rule": "No reservation conditions are set for your board type. Please contact reception.",
    "share_q": "Would you like to share your table with another room?",
    "yes_add_room": "Yes, Add Room",
    "no_proceed": "No, Proceed",
    "shared_with": "Shared with Room",
    "maintenance_title": "System Temporarily Unavailable",
    "maintenance_note": "We are performing scheduled maintenance to improve your experience. The reservation service will be available again shortly. For immediate assistance, please contact our reception team.",
    "menu": "Menu",
    "choose_dishes": "Choose Your Dishes",
    "skip": "Skip",
    "total": "Total",
    "pay_at_restaurant": "Menu Prices Apply. Payment Is Made at the Restaurant.",
    "board_included": "Included in Your Stay",
    "board_charged": "Menu Prices Apply",
    "extra_charge": "Additional Charge",
    "extra_charge_note": "This reservation is not included in your board and will be charged {amount}.",
    "book_restaurant": "Reserve a Restaurant",
    "my_bookings": "My Reservations",
    "status_confirmed": "Confirmed",
    "booked_on": "Reserved on",
    "cancel_q": "Cancel this reservation?",
    "cancel_yes": "Yes, Cancel",
    "keep_it": "Keep It",
    "status_cancelled": "Cancelled",
    "status_seated": "Seated",
    "status_no_show": "No-Show",
    "booking_ref": "Reservation No.",
    "manage_note": "You can view or cancel this reservation anytime in My Reservations.",
    "cancelled_on": "Cancelled on",
    "hi": "Hi",
    "our_restaurants": "Our Restaurants",
    "booking_details": "Reservation Details",
    "choose_datetime": "Choose Date & Time",
    "no_dates": "No available dates for this restaurant during your stay.",
    "back": "Back",
    "close": "Close",
    "remove": "Remove",
    "backspace": "Backspace",
    "fewer": "Fewer",
    "more": "More",
    "language": "Language",
    "still_there": "Are you still there?",
    "im_here": "I'm here",
    "hm_experience": "Honeymoon",
    "hm_happy": "Happy Honeymoon",
    "hm_welcome_msg": "On behalf of the whole KaiSol Romance Resort management, it is our honour to share your honeymoon with you. Wishing you a stay full of love, relaxation and unforgettable memories.",
    "hm_congrats": "Congratulations on your honeymoon",
    "hm_complimentary": "Free",
    "hm_choose_exp": "Your two moments",
    "hm_choose_venue": "Choose your venue",
    "hm_two_sub": "One dinner and one breakfast — any day, even together.",
    "hm_dinner": "Romantic Dinner",
    "hm_dinner_sub": "An intimate candle-lit dinner for two, on the beach.",
    "hm_breakfast": "Honeymoon Breakfast",
    "hm_choose_breakfast": "Choose Your Breakfast",
    "hm_choose_dinner": "Choose Your Dinner",
    "hm_breakfast_sub": "A relaxed morning together, served in your room.",
    "hm_available": "Available",
    "hm_reserved": "Reserved",
    "hm_set_menu": "Set Menu",
    "hm_no_charge": "For two guests · no charge",
    "hm_choose_menu": "Choose your menu",
    "hm_dishes": "dishes",
    "hm_sections": "sections",
    "hm_choose_one": "Choose one",
    "hm_choose_any": "Choose your favourites",
    "hm_choose_evening": "Choose your evening",
    "hm_choose_morning": "Choose your morning",
    "hm_reserved_title": "It’s reserved",
    "hm_reserved_sub": "We can’t wait to make it unforgettable.",
    "hm_your_choices": "Your Choices",
    "hm_how_you_like": "How You Like It",
    "hm_location": "Location",
    "hm_your_menu": "Your Menu",
    "err_hm_not_eligible": "This experience is reserved for our honeymoon guests.",
    "err_hm_already": "You have already reserved this experience.",
    "err_hm_slot_full": "That time is fully booked. Please choose another.",
    "err_hm_closed_date": "That date is unavailable for booking.",
    "err_rate_limited": "Too many attempts. Please wait a minute and try again.",
    "err_hm_disabled": "The honeymoon experience is not available right now.",
    "report_issue": "Scan to report a kiosk issue",
    "review_confirm": "Review & Confirm",
    "when": "When",
    "closed": "Closed",
    "table_for": "Serves",
    "special_occasion": "Special Occasion",
    "diet": "Diet",
    "allergies": "Allergies",
    "dietary": "Dietary",
    "reserve": "Reserve",
    "reserving": "Reserving…",
    "next": "Next",
    "checking": "Checking…",
    "loading": "Loading…",
    "change": "Change",
    "enter_details": "Enter Your Details",
    "room_number": "Room Number",
    "room": "Room",
    "departure_date": "Departure Date",
    "select_date": "Select Date",
    "welcome": "Welcome",
    "room_added": "Room Added",
    "confirmed": "Reservation Confirmed",
    "chargeable": "Chargeable",
    "done": "Done",
    "new_booking": "New Reservation",
    "cancel": "Cancel",
    "no_bookings": "No reservations for your stay yet.",
    "restaurant": "restaurant",
    "at": "at",
    "server_error": "Cannot reach the server",
    "birthday": "Birthday",
    "honeymoon": "Honeymoon",
    "anniversary": "Anniversary",
    "eggs": "Eggs",
    "peanuts": "Peanuts",
    "soya": "Soya",
    "sesame": "Sesame",
    "wheat": "Wheat",
    "fish": "Fish",
    "mustard": "Mustard",
    "gluten_free": "Gluten-Free",
    "nut_free": "Nut-Free",
    "lactose_free": "Lactose-Free",
    "vegetarian": "Vegetarian",
    "no_seafood": "No Seafood",
    "vegan": "Vegan",
    "confirm": "Confirm",
    "your_order": "Your Order",
    "review_note": "Please review your order before confirming."
  },
  "fr": {
    "warn_title": "Veuillez vérifier vos informations",
    "notice_title": "Opération impossible",
    "error_title": "Un point requiert votre attention",
    "ok": "OK",
    "arrival": "Arrivée",
    "departure": "Départ",
    "room_no": "N° de chambre",
    "view_menu": "Voir le menu",
    "gluten_free_menu": "Menu sans gluten",
    "and": "et",
    "nights": "Nuits",
    "board": "Formule",
    "guests": "Personnes",
    "err_invalid_room": "Le numéro de chambre {room} n’est pas valide.",
    "err_no_stay": "La chambre {room} n’est pas occupée actuellement.",
    "err_departure_required": "Veuillez indiquer votre date de départ.",
    "err_mismatch": "Le numéro de chambre et la date de départ ne correspondent pas à nos données.",
    "err_past_date": "Cette date est déjà passée.",
    "err_outside_stay": "Cette date est en dehors de votre séjour.",
    "err_maintenance": "Le système est fermé pour maintenance.",
    "err_work_time": "Les réservations sont ouvertes entre {open} et {close}.",
    "err_no_shared": "Les tables partagées ne sont pas disponibles dans ce restaurant.",
    "err_companion_not_found": "Aucun client en séjour dans la chambre {room}.",
    "err_companion_mismatch": "Chambre {room} : la date de départ ne correspond pas.",
    "err_last_day": "Aucune réservation n’est possible le jour de votre départ.",
    "err_same_day_closed": "Les réservations pour le jour même sont possibles jusqu’à {time}.",
    "err_same_day_limit": "Un maximum de {n} réservation(s) par jour.",
    "err_slot_closed": "Cet horaire n’est plus disponible.",
    "err_slot_full": "Il ne reste que {n} place(s) à {time}.",
    "err_disabled": "Le service « Mes réservations » est momentanément indisponible.",
    "err_cancel_disabled": "Veuillez contacter la réception pour annuler cette réservation.",
    "err_cancel_closed": "Les annulations pour le jour même sont possibles jusqu’à {time}.",
    "err_cancel_not_found": "Cette réservation ne peut plus être annulée.",
    "err_min_stay": "Les réservations nécessitent un séjour d’au moins {n} nuits.",
    "err_quota": "Vous avez utilisé toutes les réservations incluses dans votre séjour.",
    "err_quota_window": "Votre formule permet {n} réservation(s) par {days} jour(s).",
    "err_no_rule": "Aucune condition de réservation n’est définie pour votre formule. Veuillez contacter la réception.",
    "share_q": "Souhaitez-vous partager votre table avec une autre chambre ?",
    "yes_add_room": "Oui, ajouter une chambre",
    "no_proceed": "Non, continuer",
    "shared_with": "Partagée avec la chambre",
    "maintenance_title": "Système temporairement indisponible",
    "maintenance_note": "Nous effectuons une maintenance planifiée afin d’améliorer votre expérience. Le service de réservation sera de nouveau disponible très prochainement. Pour toute assistance, veuillez contacter notre réception.",
    "menu": "Menu",
    "choose_dishes": "Choisissez vos plats",
    "skip": "Passer",
    "total": "Total",
    "pay_at_restaurant": "Les prix de la carte s’appliquent. Le paiement s’effectue au restaurant.",
    "board_included": "Inclus dans votre séjour",
    "board_charged": "Les prix de la carte s’appliquent",
    "extra_charge": "Supplément",
    "extra_charge_note": "Cette réservation n’est pas incluse dans votre formule et sera facturée {amount}.",
    "book_restaurant": "Réserver un restaurant",
    "my_bookings": "Mes réservations",
    "status_confirmed": "Confirmée",
    "booked_on": "Réservée le",
    "cancel_q": "Annuler cette réservation ?",
    "cancel_yes": "Oui, annuler",
    "keep_it": "Conserver",
    "status_cancelled": "Annulée",
    "status_seated": "À table",
    "status_no_show": "Absence",
    "booking_ref": "Référence",
    "manage_note": "Vous pouvez consulter ou annuler cette réservation à tout moment dans Mes réservations.",
    "cancelled_on": "Annulée le",
    "hi": "Bonjour",
    "our_restaurants": "Nos restaurants",
    "booking_details": "Détails de la réservation",
    "choose_datetime": "Choisissez la date et l’heure",
    "no_dates": "Aucune date disponible pour ce restaurant pendant votre séjour.",
    "back": "Retour",
    "close": "Fermer",
    "remove": "Retirer",
    "backspace": "Effacer",
    "fewer": "Moins",
    "more": "Plus",
    "language": "Langue",
    "still_there": "Êtes-vous toujours là ?",
    "im_here": "Je suis là",
    "hm_experience": "Lune de Miel",
    "hm_happy": "Joyeuse Lune de Miel",
    "hm_welcome_msg": "Au nom de toute la direction du KaiSol Romance Resort, c'est un honneur de partager votre lune de miel. Nous vous souhaitons un séjour rempli d'amour, de détente et de souvenirs inoubliables.",
    "hm_congrats": "Félicitations pour votre lune de miel",
    "hm_complimentary": "Offert",
    "hm_choose_exp": "Vos deux moments",
    "hm_choose_venue": "Choisissez votre lieu",
    "hm_two_sub": "Un dîner et un petit-déjeuner — n’importe quel jour, même ensemble.",
    "hm_dinner": "Dîner Romantique",
    "hm_dinner_sub": "Un dîner romantique aux chandelles pour deux, sur la plage.",
    "hm_breakfast": "Petit-déjeuner de Lune de Miel",
    "hm_choose_breakfast": "Choisissez votre petit-déjeuner",
    "hm_choose_dinner": "Choisissez votre dîner",
    "hm_choose_one": "Choisissez-en un",
    "hm_choose_any": "Choisissez vos favoris",
    "hm_breakfast_sub": "Une matinée détendue à deux, servie dans votre chambre.",
    "hm_available": "Disponible",
    "hm_reserved": "Réservé",
    "hm_set_menu": "Menu Fixe",
    "hm_no_charge": "Pour deux personnes · offert",
    "hm_choose_evening": "Choisissez votre soirée",
    "hm_choose_morning": "Choisissez votre matinée",
    "hm_reserved_title": "C’est réservé",
    "hm_reserved_sub": "Nous avons hâte de rendre ce moment inoubliable.",
    "hm_your_choices": "Vos choix",
    "hm_how_you_like": "Comme vous l'aimez",
    "hm_location": "Lieu",
    "hm_your_menu": "Votre menu",
    "err_hm_not_eligible": "Cette expérience est réservée à nos couples en lune de miel.",
    "err_hm_already": "Vous avez déjà réservé cette expérience.",
    "err_hm_slot_full": "Cet horaire est complet. Veuillez en choisir un autre.",
    "err_hm_closed_date": "Cette date n'est pas disponible à la réservation.",
    "err_rate_limited": "Trop de tentatives. Veuillez patienter une minute et réessayer.",
    "err_hm_disabled": "L’expérience lune de miel n’est pas disponible pour le moment.",
    "report_issue": "Scannez pour signaler un problème",
    "review_confirm": "Vérifiez et confirmez",
    "when": "Date et heure",
    "closed": "Fermé",
    "table_for": "Pour",
    "special_occasion": "Occasion spéciale",
    "diet": "Régime",
    "allergies": "Allergies",
    "dietary": "Préférences",
    "reserve": "Réserver",
    "reserving": "Réservation en cours…",
    "next": "Suivant",
    "checking": "Vérification…",
    "loading": "Chargement…",
    "change": "Modifier",
    "enter_details": "Saisissez vos informations",
    "room_number": "Numéro de chambre",
    "room": "Chambre",
    "departure_date": "Date de départ",
    "select_date": "Choisir une date",
    "welcome": "Bienvenue",
    "room_added": "Chambre ajoutée",
    "confirmed": "Réservation confirmée",
    "chargeable": "Payant",
    "done": "Terminé",
    "new_booking": "Nouvelle réservation",
    "cancel": "Annuler",
    "no_bookings": "Pas encore de réservation pour votre séjour.",
    "restaurant": "restaurant",
    "at": "à",
    "server_error": "Impossible de joindre le serveur",
    "birthday": "Anniversaire",
    "honeymoon": "Lune de miel",
    "anniversary": "Anniversaire de mariage",
    "eggs": "œufs",
    "peanuts": "arachides",
    "soya": "soja",
    "sesame": "sésame",
    "wheat": "blé",
    "fish": "poisson",
    "mustard": "moutarde",
    "gluten_free": "sans gluten",
    "nut_free": "sans fruits à coque",
    "lactose_free": "sans lactose",
    "vegetarian": "végétarien",
    "no_seafood": "sans fruits de mer",
    "vegan": "végétalien",
    "confirm": "Confirmer",
    "your_order": "Votre commande",
    "review_note": "Veuillez vérifier votre commande avant de confirmer."
  },
  "de": {
    "warn_title": "Bitte überprüfen Sie Ihre Angaben",
    "notice_title": "Vorgang nicht möglich",
    "error_title": "Bitte beachten Sie",
    "ok": "OK",
    "arrival": "Anreise",
    "departure": "Abreise",
    "room_no": "Zimmer-Nr.",
    "view_menu": "Speisekarte ansehen",
    "gluten_free_menu": "Glutenfreie Speisekarte",
    "and": "und",
    "nights": "Nächte",
    "board": "Verpflegung",
    "guests": "Gäste",
    "err_invalid_room": "Zimmer {room} ist keine gültige Zimmernummer.",
    "err_no_stay": "Zimmer {room} ist derzeit nicht belegt.",
    "err_departure_required": "Bitte wählen Sie Ihr Abreisedatum.",
    "err_mismatch": "Zimmernummer und Abreisedatum stimmen nicht mit unseren Daten überein.",
    "err_past_date": "Dieses Datum liegt bereits in der Vergangenheit.",
    "err_outside_stay": "Dieses Datum liegt außerhalb Ihres Aufenthalts.",
    "err_maintenance": "Das System ist wegen Wartungsarbeiten geschlossen.",
    "err_work_time": "Reservierungen sind zwischen {open} und {close} möglich.",
    "err_no_shared": "Gemeinschaftstische sind in diesem Restaurant nicht verfügbar.",
    "err_companion_not_found": "Im Zimmer {room} ist derzeit kein Gast gemeldet.",
    "err_companion_mismatch": "Zimmer {room}: Das Abreisedatum stimmt nicht überein.",
    "err_last_day": "Am Abreisetag sind keine Reservierungen möglich.",
    "err_same_day_closed": "Reservierungen für denselben Tag sind bis {time} möglich.",
    "err_same_day_limit": "Pro Tag sind nur {n} Reservierung(en) möglich.",
    "err_slot_closed": "Diese Uhrzeit ist nicht mehr verfügbar.",
    "err_slot_full": "Um {time} sind nur noch {n} Plätze frei.",
    "err_disabled": "„Meine Reservierungen“ ist derzeit nicht verfügbar.",
    "err_cancel_disabled": "Bitte wenden Sie sich an die Rezeption, um diese Reservierung zu stornieren.",
    "err_cancel_closed": "Stornierungen für denselben Tag sind bis {time} möglich.",
    "err_cancel_not_found": "Diese Reservierung kann nicht mehr storniert werden.",
    "err_min_stay": "Reservierungen sind ab einem Aufenthalt von mindestens {n} Nächten möglich.",
    "err_quota": "Das Reservierungskontingent für Ihren Aufenthalt ist bereits ausgeschöpft.",
    "err_quota_window": "Mit Ihrer Verpflegung sind {n} Reservierung(en) pro {days} Tag(e) möglich.",
    "err_no_rule": "Für Ihre Verpflegung sind keine Reservierungsbedingungen hinterlegt. Bitte wenden Sie sich an die Rezeption.",
    "share_q": "Möchten Sie Ihren Tisch mit einem anderen Zimmer teilen?",
    "yes_add_room": "Ja, Zimmer hinzufügen",
    "no_proceed": "Nein, fortfahren",
    "shared_with": "Geteilt mit Zimmer",
    "maintenance_title": "System vorübergehend nicht verfügbar",
    "maintenance_note": "Wir führen derzeit planmäßige Wartungsarbeiten durch, um unseren Service für Sie zu verbessern. Der Reservierungsservice steht in Kürze wieder zur Verfügung. Für Unterstützung wenden Sie sich bitte an unsere Rezeption.",
    "menu": "Speisekarte",
    "choose_dishes": "Wählen Sie Ihre Gerichte",
    "skip": "Überspringen",
    "total": "Gesamt",
    "pay_at_restaurant": "Es gelten die Preise der Speisekarte. Die Zahlung erfolgt im Restaurant.",
    "board_included": "In Ihrem Aufenthalt inbegriffen",
    "board_charged": "Es gelten die Preise der Speisekarte",
    "extra_charge": "Aufpreis",
    "extra_charge_note": "Diese Reservierung ist in Ihrer Verpflegung nicht inbegriffen und wird mit {amount} berechnet.",
    "book_restaurant": "Restaurant reservieren",
    "my_bookings": "Meine Reservierungen",
    "status_confirmed": "Bestätigt",
    "booked_on": "Reserviert am",
    "cancel_q": "Diese Reservierung stornieren?",
    "cancel_yes": "Ja, stornieren",
    "keep_it": "Behalten",
    "status_cancelled": "Storniert",
    "status_seated": "Platziert",
    "status_no_show": "Nicht erschienen",
    "booking_ref": "Referenznummer",
    "manage_note": "Sie können diese Reservierung jederzeit unter „Meine Reservierungen“ ansehen oder stornieren.",
    "cancelled_on": "Storniert am",
    "hi": "Guten Tag",
    "our_restaurants": "Unsere Restaurants",
    "booking_details": "Reservierungsdetails",
    "choose_datetime": "Wählen Sie Datum und Uhrzeit",
    "no_dates": "Für dieses Restaurant sind während Ihres Aufenthalts keine Termine verfügbar.",
    "back": "Zurück",
    "close": "Schließen",
    "remove": "Entfernen",
    "backspace": "Löschen",
    "fewer": "Weniger",
    "more": "Mehr",
    "language": "Sprache",
    "still_there": "Sind Sie noch da?",
    "im_here": "Ich bin da",
    "hm_experience": "Flitterwochen",
    "hm_happy": "Frohe Flitterwochen",
    "hm_welcome_msg": "Im Namen der gesamten Geschäftsleitung des KaiSol Romance Resort ist es uns eine Ehre, Ihre Flitterwochen zu begleiten. Wir wünschen Ihnen einen Aufenthalt voller Liebe, Erholung und unvergesslicher Momente.",
    "hm_congrats": "Herzlichen Glückwunsch zu Ihren Flitterwochen",
    "hm_complimentary": "Gratis",
    "hm_choose_exp": "Ihre zwei Momente",
    "hm_choose_venue": "Wählen Sie Ihren Ort",
    "hm_two_sub": "Ein Abendessen und ein Frühstück — an jedem Tag, auch zusammen.",
    "hm_dinner": "Romantisches Abendessen",
    "hm_dinner_sub": "Ein romantisches Candle-Light-Dinner zu zweit, am Strand.",
    "hm_breakfast": "Flitterwochen-Frühstück",
    "hm_choose_breakfast": "Wählen Sie Ihr Frühstück",
    "hm_choose_dinner": "Wählen Sie Ihr Abendessen",
    "hm_choose_one": "Wählen Sie eines",
    "hm_choose_any": "Wählen Sie Ihre Favoriten",
    "hm_breakfast_sub": "Ein entspannter Morgen zu zweit, serviert auf Ihrem Zimmer.",
    "hm_available": "Verfügbar",
    "hm_reserved": "Reserviert",
    "hm_set_menu": "Menü",
    "hm_no_charge": "Für zwei Personen · gratis",
    "hm_choose_evening": "Wählen Sie Ihren Abend",
    "hm_choose_morning": "Wählen Sie Ihren Morgen",
    "hm_reserved_title": "Es ist reserviert",
    "hm_reserved_sub": "Wir freuen uns darauf, es unvergesslich zu machen.",
    "hm_your_choices": "Ihre Auswahl",
    "hm_how_you_like": "Ganz nach Ihrem Geschmack",
    "hm_location": "Ort",
    "hm_your_menu": "Ihr Menü",
    "err_hm_not_eligible": "Dieses Erlebnis ist unseren Hochzeitsreisenden vorbehalten.",
    "err_hm_already": "Sie haben dieses Erlebnis bereits reserviert.",
    "err_hm_slot_full": "Diese Zeit ist ausgebucht. Bitte wählen Sie eine andere.",
    "err_hm_closed_date": "Dieses Datum ist nicht buchbar.",
    "err_rate_limited": "Zu viele Versuche. Bitte warten Sie eine Minute und versuchen Sie es erneut.",
    "err_hm_disabled": "Das Flitterwochen-Erlebnis ist derzeit nicht verfügbar.",
    "report_issue": "Scannen, um ein Problem zu melden",
    "review_confirm": "Prüfen und bestätigen",
    "when": "Wann",
    "closed": "Geschlossen",
    "table_for": "Für",
    "special_occasion": "Besonderer Anlass",
    "diet": "Ernährung",
    "allergies": "Allergien",
    "dietary": "Präferenzen",
    "reserve": "Reservieren",
    "reserving": "Wird reserviert…",
    "next": "Weiter",
    "checking": "Wird geprüft…",
    "loading": "Wird geladen…",
    "change": "Ändern",
    "enter_details": "Ihre Angaben",
    "room_number": "Zimmernummer",
    "room": "Zimmer",
    "departure_date": "Abreisedatum",
    "select_date": "Datum wählen",
    "welcome": "Herzlich willkommen",
    "room_added": "Zimmer hinzugefügt",
    "confirmed": "Reservierung bestätigt",
    "chargeable": "Kostenpflichtig",
    "done": "Fertig",
    "new_booking": "Neue Reservierung",
    "cancel": "Stornieren",
    "no_bookings": "Noch keine Reservierungen für Ihren Aufenthalt.",
    "restaurant": "Restaurant",
    "at": "um",
    "server_error": "Server nicht erreichbar",
    "birthday": "Geburtstag",
    "honeymoon": "Flitterwochen",
    "anniversary": "Jahrestag",
    "eggs": "Eier",
    "peanuts": "Erdnüsse",
    "soya": "Soja",
    "sesame": "Sesam",
    "wheat": "Weizen",
    "fish": "Fisch",
    "mustard": "Senf",
    "gluten_free": "glutenfrei",
    "nut_free": "nussfrei",
    "lactose_free": "laktosefrei",
    "vegetarian": "vegetarisch",
    "no_seafood": "ohne Meeresfrüchte",
    "vegan": "vegan",
    "confirm": "Bestätigen",
    "your_order": "Ihre Bestellung",
    "review_note": "Bitte überprüfen Sie Ihre Bestellung, bevor Sie bestätigen."
  },
  "ru": {
    "warn_title": "Проверьте введённые данные",
    "notice_title": "Не удалось выполнить",
    "error_title": "Обратите внимание",
    "ok": "ОК",
    "arrival": "Заезд",
    "departure": "Выезд",
    "room_no": "№ комнаты",
    "view_menu": "Открыть меню",
    "gluten_free_menu": "Меню без глютена",
    "and": "и",
    "nights": "Ночей",
    "board": "Тип питания",
    "guests": "Гости",
    "err_invalid_room": "Номера {room} не существует.",
    "err_no_stay": "Номер {room} сейчас не занят.",
    "err_departure_required": "Пожалуйста, выберите дату выезда.",
    "err_mismatch": "Номер комнаты и дата выезда не совпадают с нашими данными.",
    "err_past_date": "Эта дата уже прошла.",
    "err_outside_stay": "Эта дата не входит в период вашего проживания.",
    "err_maintenance": "Система закрыта на техническое обслуживание.",
    "err_work_time": "Бронирование доступно с {open} до {close}.",
    "err_no_shared": "В этом ресторане общие столики недоступны.",
    "err_companion_not_found": "В номере {room} нет проживающих гостей.",
    "err_companion_mismatch": "Номер {room}: дата выезда не совпадает.",
    "err_last_day": "В день выезда бронирование недоступно.",
    "err_same_day_closed": "Бронирование на текущий день закрывается в {time}.",
    "err_same_day_limit": "В день можно оформить не более {n} бронирований.",
    "err_slot_closed": "Это время больше недоступно.",
    "err_slot_full": "На {time} осталось всего {n} мест.",
    "err_disabled": "Раздел «Мои бронирования» сейчас недоступен.",
    "err_cancel_disabled": "Для отмены бронирования обратитесь, пожалуйста, на стойку регистрации.",
    "err_cancel_closed": "Отмена бронирования на текущий день возможна до {time}.",
    "err_cancel_not_found": "Это бронирование уже нельзя отменить.",
    "err_min_stay": "Бронирование доступно при проживании не менее {n} ночей.",
    "err_quota": "Лимит бронирований на период проживания исчерпан.",
    "err_quota_window": "Ваш тип питания допускает не более {n} бронирований за {days} дн.",
    "err_no_rule": "Для вашего типа питания не заданы условия бронирования. Обратитесь, пожалуйста, на стойку регистрации.",
    "share_q": "Хотите разделить столик с гостями из другого номера?",
    "yes_add_room": "Да, добавить номер",
    "no_proceed": "Нет, продолжить",
    "shared_with": "Общий столик с номером",
    "maintenance_title": "Система временно недоступна",
    "maintenance_note": "Мы проводим плановое техническое обслуживание, чтобы сделать сервис ещё лучше. Система бронирования снова заработает в ближайшее время. По любым вопросам обращайтесь, пожалуйста, на стойку регистрации.",
    "menu": "Меню",
    "choose_dishes": "Выберите блюда",
    "skip": "Пропустить",
    "total": "Итого",
    "pay_at_restaurant": "Действуют цены меню. Оплата производится в ресторане.",
    "board_included": "Включено в ваше проживание",
    "board_charged": "Действуют цены меню",
    "extra_charge": "Доплата",
    "extra_charge_note": "Это бронирование не входит в ваш тип питания и оплачивается отдельно: {amount}.",
    "book_restaurant": "Забронировать ресторан",
    "my_bookings": "Мои бронирования",
    "status_confirmed": "Подтверждено",
    "booked_on": "Дата бронирования",
    "cancel_q": "Отменить это бронирование?",
    "cancel_yes": "Да, отменить",
    "keep_it": "Оставить",
    "status_cancelled": "Отменено",
    "status_seated": "За столом",
    "status_no_show": "Неявка",
    "booking_ref": "Номер брони",
    "manage_note": "Вы можете посмотреть или отменить это бронирование в любой момент в разделе «Мои бронирования».",
    "cancelled_on": "Дата отмены",
    "hi": "Здравствуйте",
    "our_restaurants": "Наши рестораны",
    "booking_details": "Детали бронирования",
    "choose_datetime": "Выберите дату и время",
    "no_dates": "Нет доступных дат для этого ресторана в период вашего проживания.",
    "back": "Назад",
    "close": "Закрыть",
    "remove": "Удалить",
    "backspace": "Стереть",
    "fewer": "Меньше",
    "more": "Больше",
    "language": "Язык",
    "still_there": "Вы ещё здесь?",
    "im_here": "Я здесь",
    "hm_experience": "Медовый месяц",
    "hm_happy": "Счастливого медового месяца",
    "hm_welcome_msg": "От имени всей администрации KaiSol Romance Resort для нас честь разделить с вами медовый месяц. Желаем вам отдыха, полного любви, спокойствия и незабываемых воспоминаний.",
    "hm_congrats": "Поздравляем с медовым месяцем",
    "hm_complimentary": "Бесплатно",
    "hm_choose_exp": "Два ваших момента",
    "hm_choose_venue": "Выберите место",
    "hm_two_sub": "Один ужин и один завтрак — в любой день, даже вместе.",
    "hm_dinner": "Романтический ужин",
    "hm_dinner_sub": "Романтический ужин при свечах для двоих, на пляже.",
    "hm_breakfast": "Завтрак медового месяца",
    "hm_choose_breakfast": "Выберите ваш завтрак",
    "hm_choose_dinner": "Выберите ваш ужин",
    "hm_choose_one": "Выберите одно",
    "hm_choose_any": "Выберите любимые",
    "hm_breakfast_sub": "Спокойное утро вдвоём, с завтраком в номере.",
    "hm_available": "Доступно",
    "hm_reserved": "Забронировано",
    "hm_set_menu": "Сет-меню",
    "hm_no_charge": "На двоих · бесплатно",
    "hm_choose_evening": "Выберите ваш вечер",
    "hm_choose_morning": "Выберите ваше утро",
    "hm_reserved_title": "Забронировано",
    "hm_reserved_sub": "Мы сделаем этот момент незабываемым.",
    "hm_your_choices": "Ваш выбор",
    "hm_how_you_like": "Как вам нравится",
    "hm_location": "Место",
    "hm_your_menu": "Ваше меню",
    "err_hm_not_eligible": "Этот сервис доступен только для наших молодожёнов.",
    "err_hm_already": "Вы уже забронировали это предложение.",
    "err_hm_slot_full": "Это время полностью занято. Пожалуйста, выберите другое.",
    "err_hm_closed_date": "Эта дата недоступна для бронирования.",
    "err_rate_limited": "Слишком много попыток. Пожалуйста, подождите минуту и попробуйте снова.",
    "err_hm_disabled": "Медовый месяц сейчас недоступен.",
    "report_issue": "Отсканируйте, чтобы сообщить о проблеме",
    "review_confirm": "Проверьте и подтвердите",
    "when": "Дата и время",
    "closed": "Закрыто",
    "table_for": "На",
    "special_occasion": "Особый повод",
    "diet": "Диета",
    "allergies": "Аллергии",
    "dietary": "Предпочтения",
    "reserve": "Забронировать",
    "reserving": "Бронируем…",
    "next": "Далее",
    "checking": "Проверяем…",
    "loading": "Загружаем…",
    "change": "Изменить",
    "enter_details": "Укажите ваши данные",
    "room_number": "Номер комнаты",
    "room": "Номер",
    "departure_date": "Дата выезда",
    "select_date": "Выберите дату",
    "welcome": "Добро пожаловать",
    "room_added": "Номер добавлен",
    "confirmed": "Бронирование подтверждено",
    "chargeable": "Платно",
    "done": "Готово",
    "new_booking": "Новое бронирование",
    "cancel": "Отменить",
    "no_bookings": "На период проживания бронирований пока нет.",
    "restaurant": "ресторан",
    "at": "в",
    "server_error": "Не удаётся связаться с сервером",
    "birthday": "День рождения",
    "honeymoon": "Медовый месяц",
    "anniversary": "Годовщина",
    "eggs": "яйца",
    "peanuts": "арахис",
    "soya": "соя",
    "sesame": "кунжут",
    "wheat": "пшеница",
    "fish": "рыба",
    "mustard": "горчица",
    "gluten_free": "без глютена",
    "nut_free": "без орехов",
    "lactose_free": "без лактозы",
    "vegetarian": "вегетарианское",
    "no_seafood": "без морепродуктов",
    "vegan": "веганское",
    "confirm": "Подтвердить",
    "your_order": "Ваш заказ",
    "review_note": "Пожалуйста, проверьте свой заказ перед подтверждением."
  },
  "ar": {
    "warn_title": "يرجى التحقق من بياناتكم",
    "notice_title": "نأسف، تعذر إتمام العملية",
    "error_title": "يرجى الانتباه",
    "ok": "حسنا",
    "arrival": "الوصول",
    "departure": "المغادرة",
    "room_no": "رقم الغرفة",
    "view_menu": "عرض قائمة الطعام",
    "gluten_free_menu": "قائمة خالية من الغلوتين",
    "and": "و",
    "nights": "الليالي",
    "board": "نظام الإقامة",
    "guests": "الضيوف",
    "err_invalid_room": "رقم الغرفة {room} غير صحيح.",
    "err_no_stay": "الغرفة {room} غير مشغولة حاليا.",
    "err_departure_required": "يرجى اختيار تاريخ المغادرة.",
    "err_mismatch": "رقم الغرفة وتاريخ المغادرة لا يتطابقان مع سجلاتنا.",
    "err_past_date": "لقد مضى هذا التاريخ.",
    "err_outside_stay": "هذا التاريخ خارج فترة إقامتكم.",
    "err_maintenance": "النظام مغلق حاليا لأعمال الصيانة.",
    "err_work_time": "الحجز متاح من {open} حتى {close}.",
    "err_no_shared": "الطاولات المشتركة غير متاحة في هذا المطعم.",
    "err_companion_not_found": "لا يوجد نزيل مقيم في الغرفة {room}.",
    "err_companion_mismatch": "الغرفة {room}: تاريخ المغادرة غير مطابق.",
    "err_last_day": "لا يمكن الحجز في يوم المغادرة.",
    "err_same_day_closed": "انتهى وقت الحجز لهذا اليوم، ويتاح الحجز في اليوم نفسه حتى الساعة {time} فقط.",
    "err_same_day_limit": "لا يسمح بأكثر من {n} حجز في اليوم الواحد.",
    "err_slot_closed": "لم يعد هذا الموعد متاحا.",
    "err_slot_full": "لم يتبق سوى {n} مقاعد الساعة {time}.",
    "err_disabled": "خدمة «حجوزاتي» غير متاحة حاليا.",
    "err_cancel_disabled": "يرجى التواصل مع الاستقبال لإلغاء هذا الحجز.",
    "err_cancel_closed": "يغلق إلغاء حجوزات اليوم نفسه الساعة {time}.",
    "err_cancel_not_found": "لم يعد بالإمكان إلغاء هذا الحجز.",
    "err_min_stay": "يتطلب الحجز إقامة لا تقل عن {n} ليال.",
    "err_quota": "لقد استنفدتم حصة الحجوزات المتاحة خلال إقامتكم.",
    "err_quota_window": "يتيح لكم نظام إقامتكم {n} حجز كل {days} يوم.",
    "err_no_rule": "لا توجد شروط حجز محددة لنظام إقامتكم. يرجى التواصل مع الاستقبال.",
    "share_q": "هل ترغبون بمشاركة طاولتكم مع غرفة أخرى؟",
    "yes_add_room": "نعم، إضافة غرفة",
    "no_proceed": "لا، متابعة",
    "shared_with": "مشاركة الطاولة مع غرفة",
    "maintenance_title": "النظام غير متاح مؤقتا",
    "maintenance_note": "نجري حاليا أعمال صيانة مجدولة لتحسين تجربتكم. ستعود خدمة الحجز إلى العمل خلال وقت قصير. للمساعدة الفورية، يرجى التواصل مع فريق الاستقبال.",
    "menu": "قائمة الطعام",
    "choose_dishes": "اختاروا أطباقكم",
    "skip": "تخطي",
    "total": "الإجمالي",
    "pay_at_restaurant": "تطبق أسعار قائمة الطعام. يتم الدفع في المطعم.",
    "board_included": "مشمول في إقامتكم",
    "board_charged": "تطبق أسعار قائمة الطعام",
    "extra_charge": "رسوم إضافية",
    "extra_charge_note": "هذا الحجز غير مشمول في نظام إقامتكم، وستحتسب عليه رسوم قدرها {amount}.",
    "book_restaurant": "حجز مطعم",
    "my_bookings": "حجوزاتي",
    "status_confirmed": "مؤكد",
    "booked_on": "تم الحجز في",
    "cancel_q": "هل ترغبون بإلغاء هذا الحجز؟",
    "cancel_yes": "نعم، إلغاء",
    "keep_it": "الاحتفاظ به",
    "status_cancelled": "ملغى",
    "status_seated": "تم الجلوس",
    "status_no_show": "لم يحضر",
    "booking_ref": "الرقم المرجعي",
    "manage_note": "يمكنكم عرض هذا الحجز أو إلغاؤه في أي وقت من قسم حجوزاتي.",
    "cancelled_on": "ألغي في",
    "hi": "مرحبا",
    "our_restaurants": "مطاعمنا",
    "booking_details": "تفاصيل الحجز",
    "choose_datetime": "اختاروا التاريخ والوقت",
    "no_dates": "لا توجد مواعيد متاحة لهذا المطعم خلال فترة إقامتكم.",
    "back": "رجوع",
    "close": "إغلاق",
    "remove": "إزالة",
    "backspace": "مسح",
    "fewer": "أقل",
    "more": "المزيد",
    "language": "اللغة",
    "still_there": "هل ما زلت هنا؟",
    "im_here": "نعم، أنا هنا",
    "hm_experience": "شهر العسل",
    "hm_happy": "شهر عسل سعيد",
    "hm_welcome_msg": "باسم إدارة منتجع كايسول رومانس بالكامل، يشرّفنا أن نشارككما شهر العسل. نتمنّى لكما إقامة مليئة بالحب والاسترخاء وذكريات لا تُنسى.",
    "hm_congrats": "تهانينا بمناسبة شهر العسل",
    "hm_complimentary": "مجاناً",
    "hm_choose_exp": "لحظتاكما",
    "hm_choose_venue": "اختاروا المكان",
    "hm_two_sub": "عشاء واحد وإفطار واحد — في أي يوم، وحتى معاً.",
    "hm_dinner": "عشاء رومانسي",
    "hm_dinner_sub": "عشاء رومانسي على ضوء الشموع لشخصين، على الشاطئ.",
    "hm_breakfast": "إفطار شهر العسل",
    "hm_choose_breakfast": "اختاروا فطوركم",
    "hm_choose_dinner": "اختاروا عشاءكم",
    "hm_breakfast_sub": "صباح هادئ لكما، يُقدّم في غرفتكما.",
    "hm_available": "متاح",
    "hm_reserved": "محجوز",
    "hm_set_menu": "قائمة محددة",
    "hm_no_charge": "لشخصين · مجاناً",
    "hm_choose_menu": "اختاروا قائمتكم",
    "hm_dishes": "أطباق",
    "hm_sections": "أقسام",
    "hm_choose_one": "اختاروا واحداً",
    "hm_choose_any": "اختاروا ما يعجبكم",
    "hm_choose_evening": "اختاروا أمسيتكما",
    "hm_choose_morning": "اختاروا صباحكما",
    "hm_reserved_title": "تم الحجز",
    "hm_reserved_sub": "لا نطيق الانتظار لجعلها لا تُنسى.",
    "hm_your_choices": "اختياراتكم",
    "hm_how_you_like": "كما تحبانه",
    "hm_location": "المكان",
    "hm_your_menu": "قائمتكما",
    "err_hm_not_eligible": "هذه التجربة مخصصة لضيوف شهر العسل لدينا.",
    "err_hm_already": "لقد حجزتم هذه التجربة بالفعل.",
    "err_hm_slot_full": "هذا الوقت محجوز بالكامل. يرجى اختيار وقت آخر.",
    "err_hm_closed_date": "هذا التاريخ غير متاح للحجز.",
    "err_rate_limited": "محاولات كثيرة جدًا. يرجى الانتظار دقيقة والمحاولة مرة أخرى.",
    "err_hm_disabled": "تجربة شهر العسل غير متاحة حالياً.",
    "report_issue": "امسحوا الرمز للإبلاغ عن مشكلة في الجهاز",
    "review_confirm": "راجعوا وأكدوا الحجز",
    "when": "الموعد",
    "closed": "مغلق",
    "table_for": "لـ",
    "special_occasion": "مناسبة خاصة",
    "diet": "النظام الغذائي",
    "allergies": "الحساسية",
    "dietary": "التفضيلات الغذائية",
    "reserve": "احجزوا",
    "reserving": "جار الحجز…",
    "next": "التالي",
    "checking": "جار التحقق…",
    "loading": "جار التحميل…",
    "change": "تغيير",
    "enter_details": "يرجى إدخال بياناتكم",
    "room_number": "رقم الغرفة",
    "room": "غرفة",
    "departure_date": "تاريخ المغادرة",
    "select_date": "اختاروا التاريخ",
    "welcome": "أهلا بكم",
    "room_added": "تمت إضافة الغرفة",
    "confirmed": "تم تأكيد الحجز",
    "chargeable": "تطبق",
    "done": "تم",
    "new_booking": "حجز جديد",
    "cancel": "إلغاء",
    "no_bookings": "لا توجد حجوزات خلال إقامتكم حتى الآن.",
    "restaurant": "مطعم",
    "at": "الساعة",
    "server_error": "تعذر الوصول إلى الخادم",
    "birthday": "عيد ميلاد",
    "honeymoon": "شهر العسل",
    "anniversary": "ذكرى سنوية",
    "eggs": "بيض",
    "peanuts": "فول سوداني",
    "soya": "صويا",
    "sesame": "سمسم",
    "wheat": "قمح",
    "fish": "سمك",
    "mustard": "خردل",
    "gluten_free": "خال من الغلوتين",
    "nut_free": "خال من المكسرات",
    "lactose_free": "خال من اللاكتوز",
    "vegetarian": "نباتي",
    "no_seafood": "بدون مأكولات بحرية",
    "vegan": "نباتي خالص",
    "confirm": "تأكيد",
    "your_order": "طلبكم",
    "review_note": "يرجى مراجعة طلبكم قبل التأكيد."
  },
  "it": {
    "warn_title": "Verifichi i Suoi dati",
    "notice_title": "Operazione non riuscita",
    "error_title": "Si è verificato un problema",
    "ok": "OK",
    "arrival": "Arrivo",
    "departure": "Partenza",
    "room_no": "N. camera",
    "view_menu": "Vedi il menu",
    "gluten_free_menu": "Menu senza glutine",
    "and": "e",
    "nights": "Notti",
    "board": "Trattamento",
    "guests": "Ospiti",
    "err_invalid_room": "Il numero di camera {room} non è valido.",
    "err_no_stay": "La camera {room} non risulta attualmente occupata.",
    "err_departure_required": "Selezioni la data di partenza.",
    "err_mismatch": "Il numero di camera e la data di partenza non corrispondono ai nostri dati.",
    "err_past_date": "Questa data è già trascorsa.",
    "err_outside_stay": "Questa data non rientra nel Suo soggiorno.",
    "err_maintenance": "Il sistema è chiuso per manutenzione.",
    "err_work_time": "Le prenotazioni sono aperte dalle {open} alle {close}.",
    "err_no_shared": "I tavoli condivisi non sono disponibili in questo ristorante.",
    "err_companion_not_found": "Nessun ospite risulta registrato nella camera {room}.",
    "err_companion_mismatch": "Camera {room}: la data di partenza non corrisponde.",
    "err_last_day": "Non è possibile prenotare il giorno della partenza.",
    "err_same_day_closed": "Le prenotazioni per oggi si chiudono alle {time}.",
    "err_same_day_limit": "Sono consentite solo {n} prenotazione/i al giorno.",
    "err_slot_closed": "Questo orario non è più disponibile.",
    "err_slot_full": "Sono rimasti solo {n} posti alle {time}.",
    "err_disabled": "La sezione «Le mie prenotazioni» non è al momento disponibile.",
    "err_cancel_disabled": "La preghiamo di contattare la reception per annullare questa prenotazione.",
    "err_cancel_closed": "Gli annullamenti per oggi si chiudono alle {time}.",
    "err_cancel_not_found": "Questa prenotazione non può più essere annullata.",
    "err_min_stay": "Le prenotazioni richiedono un soggiorno di almeno {n} notti.",
    "err_quota": "La quota di prenotazioni prevista per il Suo soggiorno è esaurita.",
    "err_quota_window": "Il Suo trattamento consente {n} prenotazione/i ogni {days} giorno/i.",
    "err_no_rule": "Per il Suo trattamento non sono previste condizioni di prenotazione. La preghiamo di contattare la reception.",
    "share_q": "Desidera condividere il tavolo con un’altra camera?",
    "yes_add_room": "Sì, aggiungi camera",
    "no_proceed": "No, continua",
    "shared_with": "Condiviso con la camera",
    "maintenance_title": "Sistema temporaneamente non disponibile",
    "maintenance_note": "Stiamo eseguendo una manutenzione programmata per migliorare la Sua esperienza. Il servizio di prenotazione tornerà disponibile a breve. Per assistenza immediata, La preghiamo di contattare la nostra reception.",
    "menu": "Menu",
    "choose_dishes": "Scelga i Suoi piatti",
    "skip": "Salta",
    "total": "Totale",
    "pay_at_restaurant": "Si applicano i prezzi del menu. Il pagamento avviene al ristorante.",
    "board_included": "Incluso nel Suo soggiorno",
    "board_charged": "Si applicano i prezzi del menu",
    "extra_charge": "Supplemento",
    "extra_charge_note": "Questa prenotazione non è inclusa nel Suo trattamento e prevede un addebito di {amount}.",
    "book_restaurant": "Prenota un ristorante",
    "my_bookings": "Le mie prenotazioni",
    "status_confirmed": "Confermata",
    "booked_on": "Prenotata il",
    "cancel_q": "Annullare questa prenotazione?",
    "cancel_yes": "Sì, annulla",
    "keep_it": "Mantieni",
    "status_cancelled": "Annullata",
    "status_seated": "Accomodato",
    "status_no_show": "Non presentato",
    "booking_ref": "Riferimento",
    "manage_note": "Può visualizzare o annullare questa prenotazione in qualsiasi momento in Le mie prenotazioni.",
    "cancelled_on": "Annullata il",
    "hi": "Salve",
    "our_restaurants": "I nostri ristoranti",
    "booking_details": "Dettagli della prenotazione",
    "choose_datetime": "Scelga data e ora",
    "no_dates": "Nessuna data disponibile per questo ristorante durante il tuo soggiorno.",
    "back": "Indietro",
    "close": "Chiudi",
    "remove": "Rimuovi",
    "backspace": "Cancella",
    "fewer": "Meno",
    "more": "Più",
    "language": "Lingua",
    "still_there": "Sei ancora qui?",
    "im_here": "Sono qui",
    "hm_experience": "Luna di Miele",
    "hm_happy": "Buona Luna di Miele",
    "hm_welcome_msg": "A nome di tutta la direzione del KaiSol Romance Resort, è un onore condividere la vostra luna di miele. Vi auguriamo un soggiorno pieno d'amore, relax e ricordi indimenticabili.",
    "hm_congrats": "Congratulazioni per la vostra luna di miele",
    "hm_complimentary": "Offerto",
    "hm_choose_exp": "I vostri due momenti",
    "hm_choose_venue": "Scegliete il luogo",
    "hm_two_sub": "Una cena e una colazione — in qualsiasi giorno, anche insieme.",
    "hm_dinner": "Cena Romantica",
    "hm_dinner_sub": "Una cena romantica a lume di candela per due, in spiaggia.",
    "hm_breakfast": "Colazione di Luna di Miele",
    "hm_choose_breakfast": "Scegli la tua colazione",
    "hm_choose_dinner": "Scegli la tua cena",
    "hm_choose_one": "Scegline uno",
    "hm_choose_any": "Scegli i tuoi preferiti",
    "hm_breakfast_sub": "Una mattinata rilassata insieme, servita in camera.",
    "hm_available": "Disponibile",
    "hm_reserved": "Prenotato",
    "hm_set_menu": "Menu Fisso",
    "hm_no_charge": "Per due persone · offerto",
    "hm_choose_evening": "Scegliete la vostra serata",
    "hm_choose_morning": "Scegliete la vostra mattina",
    "hm_reserved_title": "È prenotato",
    "hm_reserved_sub": "Non vediamo l’ora di renderlo indimenticabile.",
    "hm_your_choices": "Le vostre scelte",
    "hm_how_you_like": "Come vi piace",
    "hm_location": "Luogo",
    "hm_your_menu": "Il vostro menù",
    "err_hm_not_eligible": "Questa esperienza è riservata ai nostri ospiti in luna di miele.",
    "err_hm_already": "Avete già prenotato questa esperienza.",
    "err_hm_slot_full": "Questo orario è al completo. Sceglietene un altro.",
    "err_hm_closed_date": "Questa data non è disponibile per la prenotazione.",
    "err_rate_limited": "Troppi tentativi. Attendete un minuto e riprovate.",
    "err_hm_disabled": "L’esperienza luna di miele non è disponibile al momento.",
    "report_issue": "Scansiona per segnalare un problema",
    "review_confirm": "Controlli e confermi",
    "when": "Quando",
    "closed": "Chiuso",
    "table_for": "Per",
    "special_occasion": "Occasione speciale",
    "diet": "Dieta",
    "allergies": "Allergie",
    "dietary": "Preferenze",
    "reserve": "Prenota",
    "reserving": "Prenotazione in corso…",
    "next": "Avanti",
    "checking": "Verifica in corso…",
    "loading": "Caricamento…",
    "change": "Modifica",
    "enter_details": "Inserisca i Suoi dati",
    "room_number": "Numero di camera",
    "room": "Camera",
    "departure_date": "Data di partenza",
    "select_date": "Selezioni la data",
    "welcome": "Benvenuti",
    "room_added": "Camera aggiunta",
    "confirmed": "Prenotazione confermata",
    "chargeable": "A pagamento",
    "done": "Fatto",
    "new_booking": "Nuova prenotazione",
    "cancel": "Annulla",
    "no_bookings": "Ancora nessuna prenotazione per il Suo soggiorno.",
    "restaurant": "ristorante",
    "at": "alle",
    "server_error": "Impossibile contattare il server",
    "birthday": "Compleanno",
    "honeymoon": "Luna di miele",
    "anniversary": "Anniversario",
    "eggs": "uova",
    "peanuts": "arachidi",
    "soya": "soia",
    "sesame": "sesamo",
    "wheat": "grano",
    "fish": "pesce",
    "mustard": "senape",
    "gluten_free": "senza glutine",
    "nut_free": "senza frutta a guscio",
    "lactose_free": "senza lattosio",
    "vegetarian": "vegetariano",
    "no_seafood": "senza frutti di mare",
    "vegan": "vegano",
    "confirm": "Conferma",
    "your_order": "Il Suo ordine",
    "review_note": "La preghiamo di verificare il Suo ordine prima di confermare."
  },
  "cs": {
    "warn_title": "Zkontrolujte prosím své údaje",
    "notice_title": "Operaci nelze dokončit",
    "error_title": "Něco je potřeba upravit",
    "ok": "OK",
    "arrival": "Příjezd",
    "departure": "Odjezd",
    "room_no": "Pokoj č.",
    "view_menu": "Zobrazit menu",
    "gluten_free_menu": "Bezlepkové menu",
    "and": "a",
    "nights": "Noci",
    "board": "Stravování",
    "guests": "Hosté",
    "err_invalid_room": "Číslo pokoje {room} není platné.",
    "err_no_stay": "Pokoj {room} není aktuálně obsazen.",
    "err_departure_required": "Vyberte prosím datum odjezdu.",
    "err_mismatch": "Číslo pokoje a datum odjezdu neodpovídají našim záznamům.",
    "err_past_date": "Toto datum již uplynulo.",
    "err_outside_stay": "Toto datum je mimo dobu vašeho pobytu.",
    "err_maintenance": "Systém je kvůli údržbě dočasně nedostupný.",
    "err_work_time": "Rezervace jsou možné od {open} do {close}.",
    "err_no_shared": "Sdílené stoly nejsou v této restauraci k dispozici.",
    "err_companion_not_found": "V pokoji {room} není ubytován žádný host.",
    "err_companion_mismatch": "Pokoj {room}: datum odjezdu neodpovídá.",
    "err_last_day": "V den odjezdu nelze provádět rezervace.",
    "err_same_day_closed": "Rezervace na dnešní den přijímáme do {time}.",
    "err_same_day_limit": "Denně je povoleno pouze {n} rezervací.",
    "err_slot_closed": "Tento čas již není k dispozici.",
    "err_slot_full": "V {time} zbývá pouze {n} míst.",
    "err_disabled": "Sekce Moje rezervace je momentálně nedostupná.",
    "err_cancel_disabled": "Pro zrušení této rezervace kontaktujte prosím recepci.",
    "err_cancel_closed": "Zrušení na dnešní den je možné do {time}.",
    "err_cancel_not_found": "Tuto rezervaci již nelze zrušit.",
    "err_min_stay": "Rezervace vyžadují pobyt alespoň {n} nocí.",
    "err_quota": "Limit rezervací pro váš pobyt byl vyčerpán.",
    "err_quota_window": "Vaše stravování umožňuje {n} rezervací na {days} dní.",
    "err_no_rule": "Pro váš typ stravování nejsou stanoveny podmínky rezervace. Kontaktujte prosím recepci.",
    "share_q": "Přejete si sdílet stůl s hosty z jiného pokoje?",
    "yes_add_room": "Ano, přidat pokoj",
    "no_proceed": "Ne, pokračovat",
    "shared_with": "Sdíleno s pokojem",
    "maintenance_title": "Systém je dočasně nedostupný",
    "maintenance_note": "Provádíme plánovanou údržbu, abychom pro vás naše služby ještě vylepšili. Rezervační služba bude brzy opět k dispozici. Potřebujete-li okamžitou pomoc, obraťte se prosím na naši recepci.",
    "menu": "Menu",
    "choose_dishes": "Vyberte si pokrmy",
    "skip": "Přeskočit",
    "total": "Celkem",
    "pay_at_restaurant": "Platí ceny dle jídelního lístku. Platba probíhá v restauraci.",
    "board_included": "Zahrnuto ve vašem pobytu",
    "board_charged": "Platí ceny dle jídelního lístku",
    "extra_charge": "Příplatek",
    "extra_charge_note": "Tato rezervace není zahrnuta ve vašem stravování a bude zpoplatněna částkou {amount}.",
    "book_restaurant": "Rezervovat restauraci",
    "my_bookings": "Moje rezervace",
    "status_confirmed": "Potvrzeno",
    "booked_on": "Rezervováno dne",
    "cancel_q": "Zrušit tuto rezervaci?",
    "cancel_yes": "Ano, zrušit",
    "keep_it": "Ponechat",
    "status_cancelled": "Zrušeno",
    "status_seated": "U stolu",
    "status_no_show": "Nedostavil se",
    "booking_ref": "Referenční číslo",
    "manage_note": "Tuto rezervaci můžete kdykoli zobrazit nebo zrušit v sekci Moje rezervace.",
    "cancelled_on": "Zrušeno dne",
    "hi": "Dobrý den",
    "our_restaurants": "Naše restaurace",
    "booking_details": "Podrobnosti rezervace",
    "choose_datetime": "Vyberte si datum a čas",
    "no_dates": "Pro tuto restauraci nejsou během vašeho pobytu k dispozici žádné termíny.",
    "back": "Zpět",
    "close": "Zavřít",
    "remove": "Odebrat",
    "backspace": "Smazat",
    "fewer": "Méně",
    "more": "Více",
    "language": "Jazyk",
    "still_there": "Jste tu ještě?",
    "im_here": "Jsem tu",
    "hm_experience": "Líbánky",
    "hm_happy": "Šťastné líbánky",
    "hm_welcome_msg": "Jménem celého vedení KaiSol Romance Resort je nám ctí sdílet vaše líbánky. Přejeme vám pobyt plný lásky, odpočinku a nezapomenutelných vzpomínek.",
    "hm_congrats": "Blahopřejeme k líbánkám",
    "hm_complimentary": "Zdarma",
    "hm_choose_exp": "Vaše dvě chvíle",
    "hm_choose_venue": "Vyberte místo",
    "hm_two_sub": "Jedna večeře a jedna snídaně — kterýkoli den, i společně.",
    "hm_dinner": "Romantická večeře",
    "hm_dinner_sub": "Romantická večeře při svíčkách pro dva, na pláži.",
    "hm_breakfast": "Líbánková snídaně",
    "hm_choose_breakfast": "Vyberte si snídani",
    "hm_choose_dinner": "Vyberte si večeři",
    "hm_choose_one": "Vyberte si jedno",
    "hm_choose_any": "Vyberte si oblíbené",
    "hm_breakfast_sub": "Poklidné ráno ve dvou, podávané na pokoji.",
    "hm_available": "K dispozici",
    "hm_reserved": "Rezervováno",
    "hm_set_menu": "Sestavené menu",
    "hm_no_charge": "Pro dva hosty · zdarma",
    "hm_choose_evening": "Vyberte si svůj večer",
    "hm_choose_morning": "Vyberte si své ráno",
    "hm_reserved_title": "Je rezervováno",
    "hm_reserved_sub": "Těšíme se, až to bude nezapomenutelné.",
    "hm_your_choices": "Vaše volby",
    "hm_how_you_like": "Jak to máte rádi",
    "hm_location": "Místo",
    "hm_your_menu": "Vaše menu",
    "err_hm_not_eligible": "Tento zážitek je vyhrazen pro naše svatebčany.",
    "err_hm_already": "Tento zážitek jste si již rezervovali.",
    "err_hm_slot_full": "Tento čas je plně obsazen. Vyberte prosím jiný.",
    "err_hm_closed_date": "Toto datum není k dispozici pro rezervaci.",
    "err_rate_limited": "Příliš mnoho pokusů. Počkejte prosím minutu a zkuste to znovu.",
    "err_hm_disabled": "Zážitek na líbánky momentálně není k dispozici.",
    "report_issue": "Naskenujte pro nahlášení problému",
    "review_confirm": "Zkontrolujte a potvrďte",
    "when": "Kdy",
    "closed": "Zavřeno",
    "table_for": "Pro",
    "special_occasion": "Zvláštní příležitost",
    "diet": "Dieta",
    "allergies": "Alergie",
    "dietary": "Stravovací omezení",
    "reserve": "Rezervovat",
    "reserving": "Rezervuji…",
    "next": "Další",
    "checking": "Ověřuji…",
    "loading": "Načítám…",
    "change": "Změnit",
    "enter_details": "Zadejte své údaje",
    "room_number": "Číslo pokoje",
    "room": "Pokoj",
    "departure_date": "Datum odjezdu",
    "select_date": "Vyberte datum",
    "welcome": "Vítejte",
    "room_added": "Pokoj přidán",
    "confirmed": "Rezervace potvrzena",
    "chargeable": "Zpoplatněno",
    "done": "Hotovo",
    "new_booking": "Nová rezervace",
    "cancel": "Zrušit",
    "no_bookings": "Pro váš pobyt zatím nemáte žádné rezervace.",
    "restaurant": "restaurace",
    "at": "v",
    "server_error": "Server je nedostupný",
    "birthday": "Narozeniny",
    "honeymoon": "Svatební cesta",
    "anniversary": "Výročí",
    "eggs": "vejce",
    "peanuts": "arašídy",
    "soya": "sója",
    "sesame": "sezam",
    "wheat": "pšenice",
    "fish": "ryby",
    "mustard": "hořčice",
    "gluten_free": "bez lepku",
    "nut_free": "bez ořechů",
    "lactose_free": "bez laktózy",
    "vegetarian": "vegetariánské",
    "no_seafood": "bez mořských plodů",
    "vegan": "veganské",
    "confirm": "Potvrdit",
    "your_order": "Vaše objednávka",
    "review_note": "Před potvrzením prosím zkontrolujte svou objednávku."
  },
  "pl": {
    "warn_title": "Prosimy sprawdzić dane",
    "notice_title": "Nie można wykonać",
    "error_title": "Coś wymaga Państwa uwagi",
    "ok": "OK",
    "arrival": "Przyjazd",
    "departure": "Wyjazd",
    "room_no": "Nr pokoju",
    "view_menu": "Zobacz menu",
    "gluten_free_menu": "Menu bezglutenowe",
    "and": "i",
    "nights": "Noce",
    "board": "Wyżywienie",
    "guests": "Goście",
    "err_invalid_room": "Numer pokoju {room} jest nieprawidłowy.",
    "err_no_stay": "Pokój {room} nie jest obecnie zajęty.",
    "err_departure_required": "Prosimy wybrać datę wyjazdu.",
    "err_mismatch": "Numer pokoju i data wyjazdu nie zgadzają się z naszymi danymi.",
    "err_past_date": "Ta data już minęła.",
    "err_outside_stay": "Ta data wykracza poza okres Państwa pobytu.",
    "err_maintenance": "System jest niedostępny z powodu prac konserwacyjnych.",
    "err_work_time": "Rezerwacje są dostępne w godzinach od {open} do {close}.",
    "err_no_shared": "Wspólne stoliki nie są dostępne w tej restauracji.",
    "err_companion_not_found": "W pokoju {room} nie ma zameldowanego gościa.",
    "err_companion_mismatch": "Pokój {room}: data wyjazdu się nie zgadza.",
    "err_last_day": "Rezerwacje nie są możliwe w dniu wyjazdu.",
    "err_same_day_closed": "Rezerwacje na ten sam dzień są przyjmowane do {time}.",
    "err_same_day_limit": "Dziennie można dokonać maksymalnie {n} rezerwacji.",
    "err_slot_closed": "Ta godzina nie jest już dostępna.",
    "err_slot_full": "Pozostało już tylko {n} miejsc o {time}.",
    "err_disabled": "Sekcja „Moje rezerwacje” jest obecnie niedostępna.",
    "err_cancel_disabled": "Aby anulować tę rezerwację, prosimy o kontakt z recepcją.",
    "err_cancel_closed": "Anulowanie w tym samym dniu jest możliwe do {time}.",
    "err_cancel_not_found": "Tej rezerwacji nie można już anulować.",
    "err_min_stay": "Rezerwacja wymaga pobytu trwającego co najmniej {n} nocy.",
    "err_quota": "Limit rezerwacji na Państwa pobyt został wykorzystany.",
    "err_quota_window": "Państwa wyżywienie umożliwia {n} rezerwacji w ciągu {days} dni.",
    "err_no_rule": "Brak warunków rezerwacji dla Państwa rodzaju wyżywienia. Prosimy o kontakt z recepcją.",
    "share_q": "Czy chcą Państwo dzielić stolik z innym pokojem?",
    "yes_add_room": "Tak, dodaj pokój",
    "no_proceed": "Nie, kontynuuj",
    "shared_with": "Dzielony z pokojem",
    "maintenance_title": "System chwilowo niedostępny",
    "maintenance_note": "Przeprowadzamy zaplanowane prace konserwacyjne, aby poprawić jakość obsługi. Usługa rezerwacji będzie wkrótce ponownie dostępna. W razie potrzeby prosimy o kontakt z naszą recepcją.",
    "menu": "Menu",
    "choose_dishes": "Wybierz dania",
    "skip": "Pomiń",
    "total": "Razem",
    "pay_at_restaurant": "Obowiązują ceny z menu. Płatność odbywa się w restauracji.",
    "board_included": "Wliczone w pobyt",
    "board_charged": "Obowiązują ceny z menu",
    "extra_charge": "Dodatkowa opłata",
    "extra_charge_note": "Ta rezerwacja nie jest objęta Państwa wyżywieniem i zostanie doliczona opłata w wysokości {amount}.",
    "book_restaurant": "Zarezerwuj restaurację",
    "my_bookings": "Moje rezerwacje",
    "status_confirmed": "Potwierdzona",
    "booked_on": "Zarezerwowano",
    "cancel_q": "Anulować tę rezerwację?",
    "cancel_yes": "Tak, anuluj",
    "keep_it": "Zachowaj",
    "status_cancelled": "Anulowana",
    "status_seated": "Przy stoliku",
    "status_no_show": "Nieobecność",
    "booking_ref": "Numer rezerwacji",
    "manage_note": "Tę rezerwację można w każdej chwili wyświetlić lub anulować w sekcji Moje rezerwacje.",
    "cancelled_on": "Anulowano",
    "hi": "Dzień dobry",
    "our_restaurants": "Nasze restauracje",
    "booking_details": "Szczegóły rezerwacji",
    "choose_datetime": "Wybierz datę i godzinę",
    "no_dates": "Brak dostępnych terminów w tej restauracji podczas Twojego pobytu.",
    "back": "Wstecz",
    "close": "Zamknij",
    "remove": "Usuń",
    "backspace": "Usuń znak",
    "fewer": "Mniej",
    "more": "Więcej",
    "language": "Język",
    "still_there": "Czy jesteś tam?",
    "im_here": "Jestem tutaj",
    "hm_experience": "Miesiąc miodowy",
    "hm_happy": "Szczęśliwego miesiąca miodowego",
    "hm_welcome_msg": "W imieniu całego kierownictwa KaiSol Romance Resort mamy zaszczyt dzielić z Wami miesiąc miodowy. Życzymy Wam pobytu pełnego miłości, relaksu i niezapomnianych wspomnień.",
    "hm_congrats": "Gratulujemy miesiąca miodowego",
    "hm_complimentary": "Gratis",
    "hm_choose_exp": "Wasze dwie chwile",
    "hm_choose_venue": "Wybierzcie miejsce",
    "hm_two_sub": "Jedna kolacja i jedno śniadanie — dowolnego dnia, nawet razem.",
    "hm_dinner": "Romantyczna kolacja",
    "hm_dinner_sub": "Romantyczna kolacja przy świecach dla dwojga, na plaży.",
    "hm_breakfast": "Śniadanie miodowe",
    "hm_choose_breakfast": "Wybierz swoje śniadanie",
    "hm_choose_dinner": "Wybierz swoją kolację",
    "hm_choose_one": "Wybierz jedno",
    "hm_choose_any": "Wybierz ulubione",
    "hm_breakfast_sub": "Spokojny poranek we dwoje, podany w Waszym pokoju.",
    "hm_available": "Dostępne",
    "hm_reserved": "Zarezerwowane",
    "hm_set_menu": "Menu stałe",
    "hm_no_charge": "Dla dwojga gości · gratis",
    "hm_choose_evening": "Wybierzcie swój wieczór",
    "hm_choose_morning": "Wybierzcie swój poranek",
    "hm_reserved_title": "Zarezerwowane",
    "hm_reserved_sub": "Nie możemy się doczekać, aby uczynić tę chwilę niezapomnianą.",
    "hm_your_choices": "Twoje wybory",
    "hm_how_you_like": "Jak lubicie",
    "hm_location": "Miejsce",
    "hm_your_menu": "Wasze menu",
    "err_hm_not_eligible": "To przeżycie jest zarezerwowane dla naszych gości w podróży poślubnej.",
    "err_hm_already": "Już zarezerwowaliście to przeżycie.",
    "err_hm_slot_full": "Ta godzina jest w pełni zarezerwowana. Wybierz inną.",
    "err_hm_closed_date": "Ta data jest niedostępna do rezerwacji.",
    "err_rate_limited": "Zbyt wiele prób. Poczekaj minutę i spróbuj ponownie.",
    "err_hm_disabled": "Przeżycie miesiąca miodowego jest obecnie niedostępne.",
    "report_issue": "Zeskanuj, aby zgłosić problem",
    "review_confirm": "Sprawdź i potwierdź",
    "when": "Kiedy",
    "closed": "Zamknięte",
    "table_for": "Dla",
    "special_occasion": "Wyjątkowa okazja",
    "diet": "Dieta",
    "allergies": "Alergie",
    "dietary": "Preferencje żywieniowe",
    "reserve": "Zarezerwuj",
    "reserving": "Rezerwowanie…",
    "next": "Dalej",
    "checking": "Sprawdzanie…",
    "loading": "Ładowanie…",
    "change": "Zmień",
    "enter_details": "Wprowadź swoje dane",
    "room_number": "Numer pokoju",
    "room": "Pokój",
    "departure_date": "Data wyjazdu",
    "select_date": "Wybierz datę",
    "welcome": "Witamy",
    "room_added": "Dodano pokój",
    "confirmed": "Rezerwacja potwierdzona",
    "chargeable": "Płatne",
    "done": "Gotowe",
    "new_booking": "Nowa rezerwacja",
    "cancel": "Anuluj",
    "no_bookings": "Nie mają Państwo jeszcze rezerwacji na czas pobytu.",
    "restaurant": "restauracja",
    "at": "o",
    "server_error": "Brak połączenia z serwerem",
    "birthday": "urodziny",
    "honeymoon": "miesiąc miodowy",
    "anniversary": "rocznica",
    "eggs": "jaja",
    "peanuts": "orzeszki ziemne",
    "soya": "soja",
    "sesame": "sezam",
    "wheat": "pszenica",
    "fish": "ryby",
    "mustard": "gorczyca",
    "gluten_free": "bezglutenowe",
    "nut_free": "bez orzechów",
    "lactose_free": "bez laktozy",
    "vegetarian": "wegetariańskie",
    "no_seafood": "bez owoców morza",
    "vegan": "wegańskie",
    "confirm": "Potwierdź",
    "your_order": "Twoje zamówienie",
    "review_note": "Prosimy sprawdzić zamówienie przed potwierdzeniem."
  }
};

// Backend-controlled overrides (loaded from /api/translations); the bundled
// dictionary stays as the offline fallback.
let overrides = {};
export const setTranslations = data => { overrides = data ?? {}; };

export const t = (lang, key) =>
  overrides[lang]?.[key] ?? translations[lang]?.[key]
  ?? overrides.en?.[key] ?? translations.en[key] ?? key;
